// Textes juridiques du site.

const UPDATED = "Dernière mise à jour : 26 octobre 2026.";

export const legalPages = {
  mentions: {
    title: "Mentions légales",
    intro: `Informations légales relatives au site du restaurant CAP SUD. ${UPDATED}`,
    sections: [
      {
        title: "Éditeur du site",
        lines: [
          "Nom commercial : CAP SUD",
          "Société : SARL M.T.E.",
          "Forme juridique : société à responsabilité limitée (SARL)",
          "Capital social : 1 500 €",
          "Adresse de l’établissement : 1 Place Lucien Boilleau, 91420 Morangis, France",
          "SIRET : 513 090 415 00011",
          "TVA intracommunautaire : FR82 513 090 415",
          "Téléphone : 01 64 48 93 38",
          "E-mail : dursun28@hotmail.com",
          "Directeur de la publication : M. Dursun Ozturk",
        ],
      },
      {
        title: "Hébergeur du site",
        lines: [
          "Emergent Labs Inc.",
          "255 California Street, Suite 550, San Francisco, CA 94111, États-Unis",
          "Contact : support@emergent.sh",
        ],
      },
      {
        title: "Conception du site et nom de domaine",
        lines: ["Site et nom de domaine créés avec Emergent (Emergent Labs Inc.)."],
      },
      {
        title: "Propriété intellectuelle",
        lines: [
          "L’ensemble des contenus de ce site (textes, logo, photographies, mise en page) est protégé par le droit de la propriété intellectuelle. Toute reproduction ou réutilisation sans autorisation préalable de l’éditeur est interdite.",
        ],
      },
      {
        title: "Informations sur la carte",
        lines: [
          "Les prix sont indiqués en euros toutes taxes comprises. Les compositions, prix et horaires affichés peuvent évoluer. Pour toute question concernant les allergènes, merci de contacter directement le restaurant.",
        ],
      },
      {
        title: "Données personnelles et cookies",
        lines: [
          "Le traitement des données personnelles collectées sur ce site est décrit dans la Politique de confidentialité. L’utilisation des cookies et traceurs est décrite dans la page Gestion des cookies.",
        ],
      },
    ],
  },

  confidentialite: {
    title: "Politique de confidentialité",
    intro: `Cette politique explique quelles données personnelles sont collectées sur le site de CAP SUD, pourquoi, pendant combien de temps et comment exercer vos droits. ${UPDATED}`,
    sections: [
      {
        title: "Responsable du traitement",
        lines: [
          "SARL M.T.E., exploitant le restaurant CAP SUD — 1 Place Lucien Boilleau, 91420 Morangis, France.",
          "Contact pour toute question relative à vos données : dursun28@hotmail.com — 01 64 48 93 38.",
        ],
      },
      {
        title: "Formulaire de contact",
        lines: [
          "Données collectées : nom, adresse e-mail, numéro de téléphone (facultatif) et contenu du message.",
          "Finalité : répondre à votre demande. Base légale : votre consentement, exprimé en cochant la case prévue avant l’envoi.",
          "Le message est enregistré sur le serveur du site et transmis par e-mail au restaurant.",
        ],
      },
      {
        title: "Demande de location de salle",
        lines: [
          "Données collectées : nom, adresse e-mail, téléphone, type d’événement, date souhaitée, nombre approximatif de personnes et message.",
          "Finalité : vous recontacter et, le cas échéant, établir un devis. Base légale : votre consentement et les mesures précontractuelles prises à votre demande.",
          "La demande est enregistrée sur le serveur du site et transmise par e-mail au restaurant.",
        ],
      },
      {
        title: "Commande à emporter (Click & Collect)",
        lines: [
          "Données utilisées : nom, téléphone, détail de la commande (produits, quantités, suppléments), remarques éventuelles, jour et heure de retrait souhaités et montant total.",
          "Finalité : composer le message de commande que vous envoyez au restaurant, puis permettre au restaurant de vous répondre et de préparer votre commande. Base légale : l’exécution du contrat de vente et les mesures précontractuelles prises à votre demande.",
          "Ces informations ne sont pas enregistrées sur le serveur du site : elles servent uniquement à préparer le message. Le contenu de votre panier est conservé uniquement dans votre navigateur (stockage local).",
        ],
      },
      {
        title: "Envoi de la commande par WhatsApp ou par SMS",
        lines: [
          "Le bouton « Envoyer ma commande » ouvre WhatsApp avec un message prérempli adressé au restaurant. Le message n’est transmis qu’au moment où vous appuyez vous-même sur « Envoyer » dans WhatsApp. WhatsApp traite alors ces données selon sa propre politique de confidentialité, disponible sur whatsapp.com.",
          "Si vous choisissez l’envoi par SMS, le message est transmis par votre opérateur téléphonique.",
          "Aucun paiement n’est effectué sur le site et aucune coordonnée bancaire n’est demandée : la commande se règle au restaurant, lors du retrait.",
        ],
      },
      {
        title: "Données techniques",
        lines: [
          "Votre adresse IP est utilisée de façon temporaire pour limiter les envois abusifs des formulaires. Elle n’est pas enregistrée avec vos messages.",
        ],
      },
      {
        title: "Destinataires des données",
        lines: [
          "Le restaurant CAP SUD (responsable et personnel habilité).",
          "Emergent Labs Inc. : hébergement du site, base de données et service d’envoi des e-mails, en qualité de sous-traitant.",
          "WhatsApp, ou votre opérateur téléphonique en cas de SMS : acheminement du message de commande que vous choisissez d’envoyer.",
          "Aucune donnée n’est vendue ni cédée à des tiers à des fins commerciales.",
        ],
      },
      {
        title: "Transferts hors de l’Union européenne",
        lines: [
          "L’hébergeur Emergent Labs Inc. est établi aux États-Unis. Les transferts de données qui en résultent sont encadrés par les clauses contractuelles types de la Commission européenne, prévues par l’accord de traitement des données d’Emergent.",
        ],
      },
      {
        title: "Durée de conservation",
        lines: [
          "Commandes : durée nécessaire au traitement de la commande ; les pièces comptables liées au paiement au restaurant sont conservées pendant la durée légale (10 ans, article L123-22 du Code de commerce).",
          "Panier : jusqu’à ce que vous le vidiez ou effaciez les données de votre navigateur.",
        ],
      },
      {
        title: "Vos droits",
        lines: [
          "Conformément au Règlement général sur la protection des données (RGPD) et à la loi « Informatique et Libertés », vous disposez d’un droit d’accès, de rectification, d’effacement, de limitation, d’opposition et de portabilité de vos données, ainsi que du droit de retirer votre consentement à tout moment et de définir des directives relatives à leur sort après votre décès.",
          "Pour exercer ces droits : dursun28@hotmail.com ou par courrier à CAP SUD, 1 Place Lucien Boilleau, 91420 Morangis. Une réponse vous sera apportée dans un délai d’un mois.",
          "Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la CNIL (www.cnil.fr).",
        ],
      },
      {
        title: "Cookies et traceurs",
        lines: ["Les cookies et traceurs utilisés sur le site sont décrits dans la page Gestion des cookies."],
      },
    ],
  },

  cgv: {
    title: "Conditions générales de vente",
    intro: `Conditions applicables aux commandes à emporter passées sur le site de CAP SUD et réglées au restaurant lors du retrait. ${UPDATED}`,
    sections: [
      {
        title: "Vendeur",
        lines: [
          "CAP SUD — SARL M.T.E., 1 Place Lucien Boilleau, 91420 Morangis, France.",
          "SIRET : 513 090 415 00011 — TVA intracommunautaire : FR82 513 090 415.",
          "Téléphone : 01 64 48 93 38 — E-mail : dursun28@hotmail.com.",
        ],
      },
      {
        title: "Champ d’application",
        lines: [
          "Les présentes conditions s’appliquent aux commandes à emporter (Click & Collect) passées sur le site. Elles ne s’appliquent pas aux consommations sur place ni aux demandes de location de salle, qui font l’objet d’un échange direct avec le restaurant.",
          "Toute commande implique l’acceptation des présentes conditions, matérialisée par la case à cocher avant l’envoi de la commande.",
        ],
      },
      {
        title: "Produits et prix",
        lines: [
          "Les produits proposés à la commande en ligne sont ceux affichés sur la page « Commander à emporter », avec leurs suppléments éventuels.",
          "Les prix sont indiqués en euros, toutes taxes comprises (TTC). Le prix applicable est celui affiché au moment de la validation de la commande.",
        ],
      },
      {
        title: "Commande",
        lines: [
          "Le client choisit ses produits, les quantités et les suppléments, sélectionne le jour et l’heure de retrait souhaités, renseigne son nom et son téléphone, accepte les présentes conditions puis vérifie le récapitulatif de sa commande.",
          "Les créneaux de retrait sont proposés par tranches de 15 minutes pendant les horaires d’ouverture, au plus tôt 30 minutes après la commande.",
          "Le bouton « Envoyer ma commande » ouvre WhatsApp avec un message prérempli adressé au restaurant. La commande n’est transmise que lorsque le client envoie ce message. Si WhatsApp n’est pas disponible, le client peut envoyer le même message par SMS ou appeler le restaurant.",
          "La commande n’est confirmée qu’après la réponse du restaurant au client.",
        ],
      },
      {
        title: "Paiement",
        lines: [
          "Aucun paiement n’est effectué sur le site et aucune coordonnée bancaire n’est demandée.",
          "La commande est réglée directement au restaurant, lors de son retrait.",
        ],
      },
      {
        title: "Retrait de la commande",
        lines: [
          "La commande est à retirer au restaurant CAP SUD, 1 Place Lucien Boilleau, 91420 Morangis, au créneau choisi.",
        ],
      },
      {
        title: "Modification et annulation",
        lines: [
          "Pour toute modification ou annulation, le client contacte le restaurant par téléphone au 01 64 48 93 38.",
          "Conformément à l’article L221-28 du Code de la consommation, le droit de rétractation ne s’applique pas aux denrées susceptibles de se détériorer ou de se périmer rapidement.",
        ],
      },
      {
        title: "Offre « canette offerte »",
        lines: [
          "Pour chaque pizza commandée à emporter, une canette est offerte. Le nombre de canettes offertes est indiqué dans le panier et dans le message de commande.",
          "L’offre ne s’applique pas aux consommations sur place.",
        ],
      },
      {
        title: "Allergènes",
        lines: ["Pour toute information sur les allergènes, le client est invité à contacter le restaurant avant de passer commande."],
      },
      {
        title: "Réclamations",
        lines: ["Toute réclamation peut être adressée au restaurant par téléphone au 01 64 48 93 38 ou par e-mail à dursun28@hotmail.com."],
      },
      {
        title: "Médiation de la consommation",
        lines: [
          "Conformément à l’article L612-1 du Code de la consommation, le client consommateur peut recourir gratuitement à un médiateur de la consommation en vue de la résolution amiable d’un litige.",
        ],
      },
      {
        title: "Données personnelles et droit applicable",
        lines: [
          "Les données collectées lors de la commande sont traitées conformément à la Politique de confidentialité du site.",
          "Les présentes conditions sont soumises au droit français.",
        ],
      },
    ],
  },

  cookies: {
    title: "Gestion des cookies",
    intro: `Informations sur les cookies et traceurs utilisés sur le site de CAP SUD. ${UPDATED}`,
    sections: [
      {
        title: "Stockage nécessaire au fonctionnement",
        lines: [
          "Le panier de commande est mémorisé dans votre navigateur (stockage local) uniquement pour conserver votre sélection. Ce stockage est strictement nécessaire et ne requiert pas de consentement.",
        ],
      },
      {
        title: "Mesure d’audience",
        lines: [
          "Le site intègre actuellement un outil de mesure d’audience (PostHog) fourni par la plateforme Emergent.",
        ],
      },
      {
        title: "Services tiers",
        lines: [
          "Polices d’écriture : le site charge ses polices depuis Google Fonts, ce qui implique la transmission de votre adresse IP à Google.",
          "Commande : le bouton « Envoyer ma commande » ouvre WhatsApp (ou WhatsApp Web sur ordinateur) dans un nouvel onglet ; aucun module WhatsApp n’est intégré au site.",
          "Itinéraire : le bouton « Itinéraire » ouvre Google Maps dans un nouvel onglet ; aucune carte Google n’est intégrée au site.",
        ],
      },
      {
        title: "Paramétrer votre navigateur",
        lines: [
          "Vous pouvez à tout moment configurer votre navigateur pour accepter ou refuser les cookies et effacer les données stockées. Le refus du stockage nécessaire peut empêcher le fonctionnement du panier.",
        ],
      },
    ],
  },
};
